module.exports = __webpack_public_path__ + "media/icons/map-icon-rectangle-active-02421147.svg";